<template>
  <v-table
    ref="table"
    :columns="table.columns"
    :rows="table.rows"
    style-class="table"
    :pagination-options="{enabled: !isReduced}"
    :select-options="{
      enabled: checkboxesEnabled,
      selectOnCheckboxOnly: true,
      disableSelectInfo: true
    }"
    :sort-options="sortOptions"
  >
    <div
      v-if="!isReduced"
      slot="table-actions"
      class="table__header"
    >
      <span
        v-if="showRowCount && table.rows.length > 0"
        style="float: left; padding-top: 5px;"
      >
        <strong>
          Total Records: {{ table.rows.length }}
        </strong>
      </span>
      <v-button
        color="transparent"
        @click="clearFilters"
      >
        Clear Filters
      </v-button>
      <slot name="optional" />
    </div>
    <div slot="selected-row-actions">
      <button>Action 1</button>
    </div>
    <template #table-row="props">
      <div v-if="props.column.actions === 'icon_only'">
        <img
          :class="props.column.class"
          class="icon-only"
          :src="props.row.typeIcon"
        >
      </div>
      <div v-if="props.column.actions === 'edit'">
        <v-button
          color="transparent"
          @click="showEditModal(props.row)"
        >
          <v-icon
            type="edit"
          />
        </v-button>
      </div>

      <div v-else-if="props.column.actions === 'edit_and_save'">
        <v-button
          v-if="!props.row.active"
          color="transparent"
          @click="switchToEdit(props.row)"
        >
          Edit
        </v-button>
        <v-button
          v-if="props.row.active"
          color="transparent"
          @click="switchToSave(props.row)"
        >
          Save
        </v-button>
      </div>

      <div v-else-if="props.column.actions ==='view_and_download'">
        <v-button
          color="transparent"
          @click="showDoc(props.row.actions[0].link)"
        >
          <v-icon
            type="show"
          />
        </v-button>
        <v-button
          color="transparent"
          @click="downloadDoc(props.row.actions[0].link)"
        >
          <v-icon
            type="download"
          />
        </v-button>
      </div>

      <div v-else-if="props.column.actions === 'download'">
        <v-button
          color="transparent"
          @click="downloadDoc(props.row.actions[0].link)"
        >
          <v-icon
            type="download"
          />
        </v-button>
      </div>

      <div v-else-if="props.column.actions === 'view'">
        <v-button
          color="transparent"
          @click="showDoc(props.row.actions[0].link)"
        >
          <v-icon
            type="show"
          />
        </v-button>
      </div>

      <div v-else-if="props.column.actions ==='checkbox_or_value'">
        <v-checkbox
          v-if="!props.formattedRow[props.column.field].value"
          :id="props.formattedRow[props.column.field].id"
          @check="onChecked"
        />
        <div v-else>
          {{ props.formattedRow[props.column.field].value }}
        </div>
      </div>
      <div v-else-if="props.column.actions === 'dropdown'">
        <template>
          <v-select
            v-if="props.row.dropdown"
            v-model="props.formattedRow[props.column.field]"
            placeholder="Selected"
            :options="dropdown"
            :disabled="!props.row.dropdown"
            :reduce="option => option"
            @input="updateSelected"
          />
          <div v-else>
            {{ props.formattedRow[props.column.field].label }}
          </div>
        </template>
      </div>
      <div v-else-if="props.row.active">
        <input
          v-model="props.formattedRow[props.column.field].value"
          type="text"
        >
      </div>

      <v-badge
        v-else-if="props.column.badge"
        :type="props.formattedRow[props.column.field].type"
        :text="props.formattedRow[props.column.field].value"
      />
      <strong v-else-if="props.column.bold">
        {{ props.formattedRow[props.column.field].value }}
      </strong>
      <router-link
        v-else-if="props.column.link && props.formattedRow[props.column.field].link.indexOf('mailto:') != 0"
        :to="props.formattedRow[props.column.field].link"
        v-text="props.formattedRow[props.column.field].value"
      />
      <a
        v-else-if="props.column.link && props.formattedRow[props.column.field].link.indexOf('mailto:') == 0"
        :href="props.formattedRow[props.column.field].link"
      >
        {{ props.formattedRow[props.column.field].value }}
      </a>
      <template v-else>
        {{ props.formattedRow[props.column.field].value }}
      </template>
    </template>
    <template
      v-if="!isReduced"
      #pagination-bottom="props"
    >
      <div class="table__pagination">
        <v-pagination
          :initial-current-page="table.initialCurrentPage"
          :initial-rows-per-page="table.initialRowsPerPage"
          :per-page="table.perPage"
          :count="props.total"
          :page-changed="props.pageChanged"
          :per-page-changed="props.perPageChanged"
        />
      </div>
    </template>
  </v-table>
</template>

<script>
  import {VueGoodTable} from 'vue-good-table';
  import Badge from "@/atoms/Badge";
  import Button from "@/atoms/Button";
  import Icon from "@/atoms/Icon";
  import CheckBox from "@/atoms/Checkbox";
  import Pagination from "@/molecules/Pagination";
  import vSelect from 'vue-select'
  import "vue-select/dist/vue-select.css";

  export default {
    components: {
      "v-table": VueGoodTable,
      "v-badge": Badge,
      "v-button": Button,
      "v-icon": Icon,
      "v-checkbox": CheckBox,
      "v-pagination": Pagination,
      "v-select": vSelect
    },
    props: {
      table: {
        type: Object,
        default: null
      },
      isReduced: {
        type: Boolean,
        default: false
      },
      checkboxesEnabled: {
        type: Boolean,
        default: false
      },
      sortOptions: {
        type: Object,
        default: () => ({})
      },
      dropdown:{
        type: [Array,Object],
        default: () => ({})
      },
      dropdownDisable:{
        type: Boolean,
        default: false
      },
      showRowCount: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        selectedDropdown:null
      }
    },
    mounted(){
      this.resetData();
    },
    methods: {
      searchFn(row, col, cellValue, searchTerm) {
        var string = JSON.stringify(cellValue);
        return string.indexOf(searchTerm) !== -1;
      },
      showEditModal(params) {
        this.$router.push('/contact');
      },
      showDoc(url) {
        this.$emit('showDoc', url);
      },
      downloadDoc(doc) {
        this.$emit('downloadDoc', doc);
      },
      onChecked(params) {
        this.$emit('onChecked', params);
      },
      clearFilters() {
        this.$refs['table'].reset();
      },
      resetData(){
        this.selectedDropdown = null;
      },
      switchToEdit(params){
        this.$emit('switchToEdit',params)
      },
      switchToSave(params){
        params.selected = this.selectedDropdown;
        this.$emit('switchToSave',params)
      },
      updateSelected(e){
        let target = {};
        target.code = e.code;
        target.label = e.label;
        this.selectedDropdown = target;
      }
    }
  };
</script>

<style lang="scss">
  @import "../../styles/shared/shared";

  $table-padding-y-sm: 10px;
  $table-padding-y-lg: 15px;
  $table-padding-x-sm: 5px;
  $table-padding-x-lg: 10px;
  .table {
    background: $white;
    border-radius: $border-radius;
    min-width: 100%;
    table-layout: fixed;
    thead {
      > tr:first-child > th {
        background-color: $zircon;
        color: $primary;
        &:first-child {
          border-top-left-radius: $border-radius;
          border-bottom-left-radius: $border-radius;
        }
        &:last-child {
          border-top-right-radius: $border-radius;
          border-bottom-right-radius: $border-radius;

        }
      }
      .vgt-checkbox-col {
        width: 1% !important;
        input[type="checkbox"] {
          vertical-align: middle;
        }
        &:after {
          display: inline-block;
          margin-left: .25em;
          content: 'Select all';
          font-weight: 400;
        }
      }
    }
    th,
    td {
      &.shrink-cell {
        width: 1% !important;
      }
      &.bold {
        font-weight: bold;
      }
      &.no-wrap {
        white-space: nowrap;
      }
    }
    th {
      white-space: nowrap;
      padding: 10px $table-padding-x-sm;
      @include minpoint(tablet) {
        padding-right: $table-padding-x-lg;
        padding-left: $table-padding-x-lg;
      }
      &.sortable {
        cursor: pointer;
        &:after {
          display: inline-block;
          vertical-align: middle;
          width: $font-size-sm;
          height: $font-size-sm;
          margin-left: .5rem;
          content: '';
          background-repeat: no-repeat;
          background-position: center;
          background-image: url("data:image/svg+xml;utf8,<svg version='1.1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 24'><path d='M12.806 9.147l-0.444-0.585c-0.357-0.476-5.478-7.296-5.413-7.307s0.13-0.076 0.054 0 0.076-0.097 0 0v0l-5.889 7.848s0.097-0.152 0.065-0.087v0s0-0.152 0-0.087v0c0 0.097 0-0.152 0 0s0 0.087 0 0 0 0 0 0-0.065-0.152 0 0-0.054-0.065 0 0v0s-0.108-0.097-0.065-0.065v0s-0.141 0-0.065 0-0.13 0 0 0h11.908c0.065 0-0.097 0-0.087 0v0h-0.076l-0.065 0.054s-0.087 0.141 0 0 0 0.087 0 0v0s0 0.152 0 0.097v0s0 0.152 0 0.097 0-0.13 0 0 0 0 0 0c-0.046-0.094-0.073-0.205-0.073-0.321 0-0.059 0.007-0.116 0.020-0.171l-0.001 0.005c0.046-0.157 0.141-0.288 0.268-0.377l0.002-0.001c0.085-0.053 0.188-0.084 0.298-0.084 0.052 0 0.102 0.007 0.149 0.020l-0.004-0.001c0.145 0.062 0.263 0.163 0.345 0.289l0.002 0.003c0.107 0.174 0.171 0.386 0.171 0.612s-0.064 0.437-0.174 0.617l0.003-0.005c-0.174 0.293-0.485 0.489-0.843 0.498l-0.001 0h-11.378c-0.078 0.009-0.169 0.015-0.261 0.015-0.199 0-0.393-0.025-0.578-0.072l0.016 0.003c-0.41-0.16-0.695-0.552-0.695-1.011 0-0.025 0.001-0.050 0.003-0.075l-0 0.003c0.004-0.288 0.105-0.552 0.273-0.76l-0.002 0.002c0.059-0.089 0.12-0.167 0.186-0.24l-0.002 0.002 0.909-1.212c0.465-0.617 0.92-1.234 1.386-1.84l1.483-1.981 1.256-1.667 0.682-0.909c0.175-0.241 0.456-0.395 0.773-0.395 0.14 0 0.272 0.030 0.392 0.084l-0.006-0.002c0.179 0.092 0.328 0.22 0.441 0.375l0.002 0.004 0.779 1.083 1.299 1.743c0.509 0.66 1.007 1.321 1.505 1.992l1.332 1.667 0.823 1.083 0.119 0.152c0.101 0.121 0.162 0.278 0.162 0.449s-0.061 0.328-0.163 0.45l0.001-0.001c-0.102 0.113-0.248 0.184-0.411 0.184s-0.31-0.071-0.411-0.183l-0-0.001z'></path><path d='M13.618 15.751c-0.152 0.195-0.292 0.401-0.455 0.595-0.368 0.509-0.747 1.007-1.083 1.505l-1.461 1.938-2.522 3.356c-0.238 0.314-0.455 0.682-0.834 0.812-0.088 0.030-0.19 0.047-0.296 0.047-0.325 0-0.613-0.163-0.784-0.412l-0.002-0.003-0.249-0.336-1.018-1.353-1.418-1.894c-0.498-0.65-0.985-1.31-1.472-1.959l-1.191-1.57-0.541-0.725c-0.169-0.203-0.271-0.466-0.271-0.752 0-0.010 0-0.019 0-0.028l-0 0.001c-0.001-0.016-0.001-0.034-0.001-0.053 0-0.478 0.31-0.884 0.741-1.027l0.008-0.002c0.057-0.008 0.123-0.012 0.189-0.012s0.133 0.004 0.197 0.013l-0.008-0.001h11.735c0.362 0.009 0.674 0.21 0.842 0.504l0.003 0.005c0.104 0.172 0.166 0.379 0.166 0.601s-0.062 0.429-0.169 0.606l0.003-0.005c-0.077 0.135-0.198 0.238-0.342 0.291l-0.005 0.001c-0.065 0.029-0.141 0.045-0.221 0.045-0.089 0-0.173-0.021-0.248-0.057l0.003 0.001c-0.172-0.125-0.282-0.326-0.282-0.552 0-0.115 0.028-0.223 0.078-0.317l-0.002 0.004c0.021-0.022 0.039-0.047 0.053-0.074l0.001-0.002s0 0.141 0 0.087 0 0 0 0 0 0.152 0 0.054 0-0.087 0 0 0 0 0 0 0.076 0.141 0 0 0.054 0.076 0 0v0l0.065 0.054h0.065c-0.097 0 0.13 0 0 0h-11.843s-0.087 0 0 0-0.076 0.065 0 0 0 0.087 0 0 0 0 0 0 0-0.087 0-0.087v0s0-0.152 0-0.097v0s0-0.141 0-0.097c0 0.108-0.054-0.13 0 0s0-0.076-0.054-0.076v0l0.238 0.303c0.325 0.433 0.639 0.866 0.963 1.288l1.375 1.83 1.581 2.014 1.158 1.645 0.639 0.855h-0.076s0 0 0 0h-0.076c0.065 0-0.141 0-0.076 0v0h-0.065s-0.087 0.087 0 0v0l0.141-0.184 0.834-1.083 1.31-1.743 1.7-1.938 1.299-1.721 0.79-1.083c0.024-0.043 0.049-0.097 0.072-0.152l0.004-0.011c0.1-0.116 0.247-0.189 0.411-0.189s0.311 0.073 0.411 0.189l0.001 0.001c0.101 0.121 0.162 0.278 0.162 0.449s-0.061 0.328-0.163 0.45l0.001-0.001z'></path></svg>");
        }
      }
      &.sorting-asc:after {
        background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 24'><path d='M13.716 8.379c0.107 0.174 0.171 0.386 0.171 0.612s-0.064 0.437-0.174 0.617l0.003-0.005c-0.174 0.293-0.485 0.489-0.843 0.498l-0.001 0h-11.356c-0.078 0.009-0.169 0.015-0.261 0.015-0.199 0-0.393-0.025-0.578-0.072l0.016 0.003c-0.41-0.16-0.695-0.552-0.695-1.011 0-0.025 0.001-0.050 0.003-0.075l-0 0.003c0.026-0.253 0.124-0.479 0.272-0.663l-0.002 0.002c0.059-0.089 0.12-0.167 0.186-0.24l-0.002 0.002 0.909-1.212c0.465-0.617 0.92-1.234 1.386-1.84l1.483-1.981 1.256-1.667 0.682-0.909c0.175-0.241 0.456-0.395 0.773-0.395 0.14 0 0.272 0.030 0.392 0.084l-0.006-0.002c0.179 0.092 0.328 0.22 0.441 0.375l0.002 0.004 0.779 1.083 1.299 1.743c0.509 0.66 1.007 1.321 1.505 1.992l1.332 1.667z'></path><path d='M13.618 15.751c-0.152 0.195-0.292 0.401-0.455 0.595-0.368 0.509-0.747 1.007-1.083 1.505l-1.461 1.938-2.522 3.356c-0.238 0.314-0.455 0.682-0.834 0.812-0.088 0.030-0.19 0.047-0.296 0.047-0.325 0-0.613-0.163-0.784-0.412l-0.002-0.003-0.249-0.336-1.018-1.353-1.418-1.894c-0.498-0.65-0.985-1.31-1.472-1.959l-1.191-1.57-0.541-0.725c-0.169-0.203-0.271-0.466-0.271-0.752 0-0.010 0-0.019 0-0.028l-0 0.001c-0.001-0.016-0.001-0.034-0.001-0.053 0-0.478 0.31-0.884 0.741-1.027l0.008-0.002c0.057-0.008 0.123-0.012 0.189-0.012s0.133 0.004 0.197 0.013l-0.008-0.001h11.735c0.362 0.009 0.674 0.21 0.842 0.504l0.003 0.005c0.104 0.172 0.166 0.379 0.166 0.601s-0.062 0.429-0.169 0.606l0.003-0.005c-0.077 0.135-0.198 0.238-0.342 0.291l-0.005 0.001c-0.065 0.029-0.141 0.045-0.221 0.045-0.089 0-0.173-0.021-0.248-0.057l0.003 0.001c-0.172-0.125-0.282-0.326-0.282-0.552 0-0.115 0.028-0.223 0.078-0.317l-0.002 0.004c0.021-0.022 0.039-0.047 0.053-0.074l0.001-0.002s0 0.141 0 0.087 0 0 0 0 0 0.152 0 0.054 0-0.087 0 0 0 0 0 0 0.076 0.141 0 0 0.054 0.076 0 0v0l0.065 0.054h0.065c-0.097 0 0.13 0 0 0h-11.843s-0.087 0 0 0-0.076 0.065 0 0 0 0.087 0 0 0 0 0 0 0-0.087 0-0.087v0s0-0.152 0-0.097v0s0-0.141 0-0.097c0 0.108-0.054-0.13 0 0s0-0.076-0.054-0.076v0l0.238 0.303c0.325 0.433 0.639 0.866 0.963 1.288l1.375 1.83 1.581 2.014 1.158 1.645 0.639 0.855h-0.076s0 0 0 0h-0.076c0.065 0-0.141 0-0.076 0v0h-0.065s-0.087 0.087 0 0v0l0.141-0.184 0.834-1.083 1.31-1.743 1.7-1.938 1.299-1.721 0.79-1.083c0.024-0.043 0.049-0.097 0.072-0.152l0.004-0.011c0.1-0.116 0.247-0.189 0.411-0.189s0.311 0.073 0.411 0.189l0.001 0.001c0.101 0.121 0.162 0.278 0.162 0.449s-0.061 0.328-0.163 0.45l0.001-0.001z'></path></svg>");
      }
      &.sorting-desc:after {
        background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 14 24'><path d='M0.173 15.621c-0.107-0.174-0.171-0.386-0.171-0.612s0.064-0.437 0.174-0.617l-0.003 0.005c0.173-0.292 0.486-0.485 0.844-0.487h11.356c0.124-0.021 0.266-0.033 0.411-0.033s0.288 0.012 0.427 0.035l-0.015-0.002c0.41 0.16 0.695 0.552 0.695 1.011 0 0.025-0.001 0.050-0.003 0.075l0-0.003c-0.017 0.279-0.116 0.533-0.273 0.739l0.002-0.003-0.184 0.227-0.909 1.223-1.386 1.83-1.483 1.981-1.256 1.667-0.682 0.909c-0.173 0.242-0.453 0.398-0.769 0.398-0.141 0-0.275-0.031-0.395-0.087l0.006 0.002c-0.181-0.089-0.33-0.218-0.441-0.375l-0.002-0.004-0.779-1.083-1.299-1.732-1.505-1.992-1.332-1.732z'></path><path d='M0.271 8.303c0.152-0.206 0.292-0.401 0.455-0.606l1.126-1.559 1.461-1.938 1.44-1.916c0.368-0.476 0.725-0.953 1.083-1.44 0.238-0.314 0.455-0.682 0.834-0.801 0.090-0.031 0.193-0.049 0.3-0.049 0.325 0 0.611 0.164 0.78 0.414l0.002 0.003 0.249 0.325 2.414 3.237c0.498 0.65 0.985 1.31 1.472 1.959l1.191 1.581 0.541 0.714c0.169 0.209 0.271 0.478 0.271 0.771 0 0.003 0 0.006-0 0.009v-0c0.001 0.016 0.001 0.034 0.001 0.053 0 0.478-0.31 0.884-0.741 1.027l-0.008 0.002c-0.057 0.008-0.123 0.012-0.189 0.012s-0.133-0.004-0.197-0.013l0.008 0.001h-11.756c-0.36-0.005-0.674-0.202-0.842-0.493l-0.003-0.005c-0.104-0.173-0.166-0.383-0.166-0.606s0.062-0.433 0.169-0.612l-0.003 0.005c0.080-0.133 0.199-0.235 0.342-0.291l0.005-0.002c0.046-0.014 0.1-0.022 0.155-0.022 0.111 0 0.215 0.032 0.302 0.088l-0.002-0.001c0.17 0.128 0.279 0.329 0.279 0.556 0 0.113-0.027 0.22-0.075 0.314l0.002-0.004v0.076s0-0.141 0-0.076 0 0 0 0 0-0.162 0-0.054 0 0.087 0 0 0 0 0 0-0.076-0.152 0 0-0.054-0.076 0 0v0l-0.065-0.054h-0.065c0.087 0-0.13 0 0 0h11.767s0.097 0 0 0 0.076-0.076 0 0 0.054-0.087 0 0 0 0 0 0 0 0.076 0 0.087v-0.054s0 0.152 0 0.097v0 0.097c0-0.097 0 0.13 0 0s0 0.065 0.054 0.076v0l-0.238-0.303-0.963-1.288c-0.465-0.606-0.92-1.223-1.375-1.83l-1.548-2.046-1.202-1.602-0.639-0.844h0.076c-0.065 0 0.141 0 0.076 0v0h0.065l-0.141 0.184-0.834 1.083-1.396 1.732-1.461 1.949-1.299 1.71-0.79 1.083-0.108 0.141c-0.1 0.116-0.247 0.189-0.411 0.189s-0.311-0.073-0.411-0.189l-0.001-0.001c-0.101-0.121-0.162-0.278-0.162-0.449s0.061-0.328 0.163-0.45l-0.001 0.001z'></path></svg>");
      }
    }
    tbody tr {
      &:nth-child(odd) {
        background: $selago;
      }
    }
    td {
      padding: $table-padding-y-sm $table-padding-x-sm;
      @include minpoint(tablet) {
        padding: $table-padding-y-lg $table-padding-x-lg;
      }
      a {
        color: $azure;
      }
    }
    &__pagination {
      margin-top: 2rem;
    }
    &__header {
      text-align: right;
      margin-bottom: .5rem;
    }
  }

  .vgt-responsive {
    width: 100%;
    overflow-x: auto;
  }

  .vgt-select,
  .vgt-input {
    width: 100%;
    max-width: 10rem;
    background-color: $white;
    border: 1px solid $pigeon;
    border-radius: $form-border-radius;
    color: $tangaroa;
    outline: none;
    margin: 0;
    font-size: $font-size-sm;
    padding: 5px 10px;
    box-shadow: none;
    transition: box-shadow 0.3s, border 0.3s;
    &:disabled,
    &[readonly="readonly"] {
      color: $casper;
      border-color: $casper;
      background: $zircon;
    }
    &:focus:not([readonly]) {
      box-shadow: 0 0 0 3px rgba($pigeon, 0.5);
    }
  }

  .flatpickr-input,
  .vgt-select {
    appearance: none;
    background-repeat: no-repeat;
    padding-right: 1.25rem;
    background-position: calc(100% - .25rem) center;
  }

  .flatpickr-input {
    background-size: 1rem;
    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 28 28'><path d='M21.521 5.461h-1.611v-0.811c0-0.249-0.204-0.45-0.456-0.45s-0.456 0.202-0.456 0.45v0.811h-4.649v-0.811c0-0.249-0.204-0.45-0.456-0.45s-0.456 0.202-0.456 0.45v0.811h-4.649v-0.811c0-0.249-0.204-0.45-0.456-0.45s-0.456 0.202-0.456 0.45v0.811h-1.398c-1.257 0-2.279 1.010-2.279 2.252v12.434c0 1.242 1.022 2.252 2.279 2.252h15.042c1.257 0 2.279-1.010 2.279-2.252v-12.434c0-1.242-1.022-2.252-2.279-2.252zM22.888 20.148c0 0.745-0.613 1.351-1.367 1.351h-15.042c-0.754 0-1.367-0.606-1.367-1.351v-8.89h17.777v8.89z'></path></svg>");
  }

  .vgt-select {
    background-size: .75rem;
    background-image: url("data:image/svg+xml;utf8,<svg version='1.1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 18 28'><path d='M16.797 11.5c0 0.125-0.063 0.266-0.156 0.359l-7.281 7.281c-0.094 0.094-0.234 0.156-0.359 0.156s-0.266-0.063-0.359-0.156l-7.281-7.281c-0.094-0.094-0.156-0.234-0.156-0.359s0.063-0.266 0.156-0.359l0.781-0.781c0.094-0.094 0.219-0.156 0.359-0.156 0.125 0 0.266 0.063 0.359 0.156l6.141 6.141 6.141-6.141c0.094-0.094 0.234-0.156 0.359-0.156s0.266 0.063 0.359 0.156l0.781 0.781c0.094 0.094 0.156 0.234 0.156 0.359z'></path></svg>");
  }
  .icon-only {
    max-width: 24px;
  }

</style>
